/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { internals } from '../../../constants';
/**
 * Mixes in Element Internals functionality into a base component.
 *
 * @param base The base component to mix into.
 * @returns The mixed-in base component.
 */
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function WithElementInternals(base) {
    class ElementInternalsComponent extends base {
        constructor(...args) {
            super(...args);
            this[internals] = this.attachInternals();
        }
    }
    return ElementInternalsComponent;
}
